import createStore from "@/utils/create-store";
import Model from "@/models/admin/users";

export default createStore({ Model });
